import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.object.to-string.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { keyExtractPath } from "../key/index.js";
import { sr25519DerivePublic } from "../sr25519/index.js";
import { decodeAddress } from "./decode.js";
import { encodeAddress } from "./encode.js";

function filterHard(_ref) {
  var isHard = _ref.isHard;
  return isHard;
}
/**
 * @name deriveAddress
 * @summary Creates a sr25519 derived address from the supplied and path.
 * @description
 * Creates a sr25519 derived address based on the input address/publicKey and the uri supplied.
 */


export function deriveAddress(who, suri, ss58Format) {
  var _keyExtractPath = keyExtractPath(suri),
      path = _keyExtractPath.path;

  assert(path.length && !path.every(filterHard), 'Expected suri to contain a combination of non-hard paths');
  var publicKey = decodeAddress(who);

  var _iterator = _createForOfIteratorHelper(path),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var chainCode = _step.value.chainCode;
      publicKey = sr25519DerivePublic(publicKey, chainCode);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return encodeAddress(publicKey, ss58Format);
}